import classNames from "classnames";
import React from "react";

interface ColumnProps {
  gap?: "bigger"
  style?: React.CSSProperties
  cellClasses?: string
  size?: "small" | "medium"
}

type LayoutProps = React.FC<React.PropsWithChildren<Props>>;

interface TwoColumnLayouts extends LayoutProps {
  LeftColumn: typeof LeftColumn
  RightColumn: typeof RightColumn
}

const LeftColumn = (props: React.PropsWithChildren<ColumnProps>) => {
  const cssClasses = classNames("grow1", props.cellClasses, {
    "flex-column panel-gap": props.gap === "bigger"
  });

  return (<div className={cssClasses}>
    {props.children}
  </div>);
};

const RightColumn = (props: React.PropsWithChildren<ColumnProps>) => {
  const cssClasses = classNames(props.cellClasses, {
    "flex-column panel-gap": props.gap === "bigger",
    smallright: props.size === "small" || props.size == null,
    mediumright: props.size === "medium"
  });

  return <div style={props.style} className={cssClasses}>
    {props.children}
  </div>;
};

interface Props {
  classes?: string
  style?: React.CSSProperties
}

const TwoColumnLayout: TwoColumnLayouts = (props: React.PropsWithChildren<Props>) => {
  const classes = classNames("flex panel-gap", props.classes);
  return <div style={props.style} id="two-column-page-layout" className={classes}>
    {props.children}
  </div>;
};

TwoColumnLayout.LeftColumn = LeftColumn;
TwoColumnLayout.RightColumn = RightColumn;

export default TwoColumnLayout;